const ChevronRight = () => {
  return (
    <svg
      width="4"
      height="8"
      viewBox="0 0 4 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.354175 7.72385C0.138544 7.55135 0.103583 7.2367 0.276088 7.02107L2.69288 4.00008L0.276088 0.979098C0.103583 0.763467 0.138544 0.448821 0.354174 0.276316C0.569805 0.103811 0.884452 0.138772 1.05696 0.354403L3.72362 3.68774C3.86971 3.87035 3.86971 4.12982 3.72362 4.31243L1.05696 7.64576C0.884452 7.8614 0.569806 7.89636 0.354175 7.72385Z"
        fill="black"
        fill-opacity="0.88"
      />
    </svg>
  );
};

export default ChevronRight;
